import React from 'react';
import { SectionHeading, Card } from '../primitives';

/** PHLD.ai — How it works. Audit → pilot → scale, toward whole-house AI transformation. Ivory. */
export function HowItWorks() {
  const steps = [
    {
      n: '01',
      t: 'Audit',
      d: 'I map how your team really works: every step, every hand-off, and find where the hours drain.',
    },
    {
      n: '02',
      t: 'Pilot',
      d: 'We take the heaviest drain and build the fix. A short pilot that proves the hours come back.',
    },
    {
      n: '03',
      t: 'Scale',
      d: 'It works, so it grows. Layer on layer, toward the AI transformation of the whole house.',
    },
  ];

  const section: React.CSSProperties = { background: 'var(--surface-canvas)' };
  const inner: React.CSSProperties = { maxWidth: 'var(--container)', margin: '0 auto', padding: 'var(--space-10) var(--gutter)' };
  const grid: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 'var(--space-5)',
    marginTop: 'var(--space-8)',
  };
  const num: React.CSSProperties = { fontWeight: 'var(--weight-extralight)' as any, fontSize: '2.5rem', color: 'var(--periwinkle-deep)', lineHeight: 1 };
  const title: React.CSSProperties = {
    fontWeight: 'var(--weight-light)' as any,
    fontSize: 'var(--text-title)',
    color: 'var(--ink-900)',
    margin: 'var(--space-4) 0 var(--space-3)',
  };
  const desc: React.CSSProperties = { fontSize: 'var(--text-body)', color: 'var(--text-muted)', lineHeight: 'var(--leading-relaxed)' };

  return (
    <section style={section} id="how-it-works">
      <div style={inner}>
        <SectionHeading
          eyebrow="How it works"
          title="Find the time-wasting processes. Automate them. Give your team back the space to Create."
          standfirst="I don't sell software. I find the work that drains your team, and build the AI that takes it away."
          maxWidth="24ch"
        />
        <div style={grid} className="phld-steps-grid">
          {steps.map((s) => (
            <Card key={s.n} padding="lg">
              <div style={num}>{s.n}</div>
              <h3 style={title}>{s.t}</h3>
              <p style={desc}>{s.d}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
